/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    number, string, array, func, arrayOf, shape, object,
} from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { withStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import { useFlags } from 'launchdarkly-react-client-sdk';
import EventDispatcher from '../../../state/reducers/EventDispatcher';
import configENV from '../../../config';
import { getFeatureFlag } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';

const { PERSIST_KEY } = configENV;
const styles = (theme) => ({
    imageContainer: {
        textAlign: 'center',
        position: 'relative',
        paddingBottom: '20px',
    },
    deleteIcon: {
        background: theme.palette?.cms?.activeButtonColor || '#E8F1ED',
        width: '70px',
        height: '70px',
        borderRadius: '50%',
        textAlign: 'center',
        position: 'absolute',
        left: '32%',
        top: '0px',
    },
    deleteImage: {
        marginTop: '14px',
        width: '39px',
        heigth: '39px',

    },
    accountButton: {
        marginTop: '6%',
        width: '82px',
        height: '82px',
    },
    buttonContainer: {
        textAlign: 'center',
        paddingTop: '24px',
        '& button': {
            borderRadius: 'inherit !important',
        },
        '& .cancelButton': {
            padding: '4px 40px 3.5px !important',
        },
        '& .red': {
            backgroundColor: theme.palette.cms?.black || '#2f2f2f !important',
            lineHeight: '20px',
            border: `1px solid  ${theme.palette.cms?.black || '#2f2f2f !important'}`,
        },
    },
    deleteContent: {
        width: '250px',
        margin: '0px auto',
        lineHeight: '2rem',
    },
    closeButtonContianer: {
        textAlign: 'right',
    },
    buttonV1Container: {
        textAlign: 'center',
    },
});
const DesktopAddressRemove = ({
    AddressId,
    addressType,
    currentPage,
    recipient,
    recipientsByPage,
    handleCloseModal,
    classes,
    handleSubmitRemoveRecipient,
}) => {
    const { experimentGiftListV2 } = useFlags();

    const GiftListV2AB = experimentGiftListV2 === 'variant';
    const giftUserV2 =  useSelector(getFeatureFlag('is-giftlist-v2-enabled')) && GiftListV2AB;
    const confirmationMessage = () => (
        addressType !== 'GIFT_LIST' ? (
            <>
                <p className={classes.deleteContent}>Are you sure you want to delete this address?</p>
            </>
        ) : (
            <>
                {giftUserV2 && (
                    <>
                        <div className={classes.closeButtonContianer}>
                            <CloseIcon onClick={() => handleCloseModal()} className={classes.closeButton} />
                        </div>
                        <div className={classes.imageContainer}>
                            <div  className={classes.deleteIcon}>
                                <img className={classes.deleteImage} src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/blt4204359aaa5c5910/632b1eb7d31e177fc6b59a6d/delete.svg?auto=webp" alt="Click to Delete" />
                            </div>
                            <img className={classes.accountButton} src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/blt7fae2dc2ebca1db0/632b1eb713b09f72eb7387d9/account.svg?auto=webp" alt="My Account" />
                        </div>
                    </>
                )}
                <p className="bodySize left">This recipient will be removed from this Gift List but will still appear in other Gift Lists and your Contacts</p>
            </>
        )
    );

    return (
        <>
            {confirmationMessage()}
            <div className={giftUserV2 ? classes.buttonContainer : classes.buttonV1Container}>
                <Button
                    onClick={() => handleCloseModal()}
                    variant="contained"
                    className="secondary margin-right-2x cancelButton"
                >
                    Cancel
                </Button>
                <Button
                    onClick={() => handleSubmitRemoveRecipient(
                        recipient.AddressBookEntryId,
                        AddressId,
                        recipient,
                        addressType,
                        currentPage,
                        recipientsByPage,
                    )}
                    variant="contained"
                    color="primary"
                    className="red"
                >
                    Delete
                </Button>
            </div>
        </>
    );
};

DesktopAddressRemove.defaultProps = {
    AddressId: -1,
    currentPage: -1,
    recipientsByPage: [],
};

DesktopAddressRemove.propTypes = {
    classes: object.isRequired,
    AddressId: number,
    currentPage: number,
    addressType: string.isRequired,
    recipient: shape({
        AddressBookEntryId: string,
        ContactId: number,
        FirstName: string,
        LastName: string,
        RelationShip: string,
        NickName: string,
        LastUpdateDate: string,
        EmployerName: string,
        NumberOfAddresses: number,
        Addresses: arrayOf(
            shape({
                AddressId: number,
                AddressBookEntryId: string,
                AddressType: string,
                AddressLineOne: string,
                AddressLineTwo: string,
                City: string,
                StateProvince: string,
                PostalCode: string,
                Country: string,
                ContactId: number,
            }),
        ),
    }).isRequired,
    recipientsByPage: array, // An empty array for now; it reserves for pagination feature
    handleCloseModal: func.isRequired,
    handleSubmitRemoveRecipient: func.isRequired,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        AddressId: newState.AddressId,
        recipient: newState.recipient,
        addressType: newState.addressType,
        currentPage: newState.giftList.currentPage,
        recipientsByPage: newState.giftList.recipientsByPage,
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleCloseModal: () => dispatch(EventDispatcher.handleCloseModal()),
    handleSubmitRemoveRecipient: (AddressBookEntryId, AddressId, recipient, addressType, currentPage, recipientsByPage) => dispatch(EventDispatcher.handleSubmitRemoveRecipient(
        AddressBookEntryId,
        AddressId,
        recipient,
        addressType,
        currentPage,
        recipientsByPage,
    )),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)((withStyles(styles))(DesktopAddressRemove));
